import React from 'react'
import { Link } from 'react-router'

import './styles/MenuBar.scss'
import backgroundImg from '../../images/background.jpg'
import homeIcon from './images/menu_home.svg'
import parentsIcon from './images/menu_parents.svg'
import ownersIcon from './images/settings_white.svg'
import resourcesIcon from './images/resources.svg'
import logoutIcon from './images/logout.svg'


const style = {
  backgroundImage: `url(${backgroundImg})`
}
const therapistStyle = {
  padding: '15px'
}

const parentStyle = {
  padding: '6px'
}

const homeStyle = {
  padding: '5px'
}

const MenuBar = (props) => {
  return (
    <div className="menu-bar">
      <div>
        <Link to="/">
          <img alt="Home" src={homeIcon} style={homeStyle} />
        </Link>
        <label>Home</label>
      </div>
      {props.user.therapist && props.user.parent && (
        <div>
          <Link to="/parents/">
            <img alt="Parent" src={parentsIcon} style={parentStyle} />
          </Link>
          <label>Patients</label>
        </div>
      )}

      {props.user.owner && (props.user.therapist || props.user.parent) && (
        <div>
          <Link to="/practice_admin/">
            <img alt="Owner" style={therapistStyle} src={ownersIcon} />
          </Link>
          <label>Owner</label>
        </div>
      )}

    {(props.user.owner || props.user.therapist || props.user.parent) &&
      (<div>
        <Link to="/page/therapy_areas">
          <img alt="Resources" src={resourcesIcon} />
        </Link>
        <label>Resources</label>
      </div>)}

      {props.user.loggedIn && (
        <div>
          <a onClick={props.onLogout}>
            <img alt="Logout" src={logoutIcon} />
          </a>
          <label>Logout</label>
        </div>
      )}
    </div>
  );
}

MenuBar.defaultProps = {
  User: {}
}

export default MenuBar



// WEBPACK FOOTER //
// ./src/components/sidenav/MenuBar.jsx